export const SIGNUPS_ENABLED =
  (import.meta.env.VITE_SIGNUPS_ENABLED ?? "true").toLowerCase() === "true";

/** When true, new signups are redirected to the beta holding page instead of the dashboard. */
export const BETA_MODE =
  (import.meta.env.VITE_BETA_MODE ?? "false").toLowerCase() === "true";
